import { COA, COAProvider } from '../../../../types/entity';
import Xero from '../../../../assets/xero.png';
import { ArrowUpTrayIcon } from '@heroicons/react/20/solid';
import plural from '../../../../utilities/plural';
import { Link } from 'react-router-dom';

type ChartOverviewProps = {
    coa?: COA;
    provider: COAProvider | null;
};

const chartProviders = {
    XERO: {
        img: <img src={Xero} className="h-8 w-8" />,
        tagline: 'Sync your chart of accounts from Xero.',
    },
};

function ChartOverview({ coa, provider }: ChartOverviewProps): JSX.Element {
    function promptIntegration(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void {
        e.preventDefault();
        e.stopPropagation();
    }

    return (
        <Link
            className="w-full border rounded-md p-4 hover:bg-gray-50"
            onClick={coa ? undefined : promptIntegration}
            to={location.pathname + location.search + `&chart=${coa?.id}`}
        >
            <div className="flex items-center gap-2 flex-wrap">
                <div className="shrink-0">
                    {provider ? (
                        chartProviders[provider]?.img
                    ) : (
                        <div className="p-1 border rounded-md">
                            <ArrowUpTrayIcon className="text-indigo-600 h-5 w-5 shrink-0" />
                        </div>
                    )}
                </div>
                <p className="capitalize text-gray-800 font-bold">{provider?.toLowerCase() ?? 'manual import'}</p>
                <div className="ml-auto text-sm text-gray-600">
                    {typeof coa?.accounts === 'number' ? (
                        <p>
                            {coa.accounts} {plural(coa.accounts, 'account')}
                        </p>
                    ) : (
                        <p>Not configured</p>
                    )}
                </div>
                <label className="basis-full text-xs text-gray-500 cursor-pointer">
                    {provider ? chartProviders[provider]?.tagline : 'Import your chart of accounts with a CSV file.'}
                </label>
            </div>
        </Link>
    );
}

export default ChartOverview;
